module.exports = __webpack_public_path__ + "static/media/MNNbanner.ed474041.jpg";